<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="公告列表" name="notice">
        <Notice v-if="activeName=='notice'"></Notice>
      </el-tab-pane>
      <!-- <el-tab-pane label="技师报备列表" name="report">
        <Report v-if="activeName=='report'"></Report>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>
<script>
import bus from "@/utils/eventBus.js";
import Notice from "./notice/index";
import Report from "./report/index";
export default {
  components: {
    Notice,
    Report
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前选中*/
      activeName: "notice"
    };
  },
  methods: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/technician/qita/index.vue